import React from 'react';

const SpecialityItem = ({ data }) => {
    const { icon, heading, bg, description } = data;

    return (
        <div className="speciality_item">
            <div className="frontend">
                <img src={icon} alt="" />
                <h6>{heading}</h6>
            </div>
            <div className="backend" style={{ backgroundImage: `url(${bg})` }}>
                <h5>{heading}</h5>
                <p>{description}</p>
            </div>



        </div>
    );
};

export default SpecialityItem;